import apiClient from '../apiClient';
import { POST_IMAGES_TOUR_OPERATOR_URL } from '../apiUrl';

const postImageTourOperatorApi = (id, data) => {
  return apiClient.post(POST_IMAGES_TOUR_OPERATOR_URL(id), data);
};

export default postImageTourOperatorApi;
